<script lang="ts" setup>
//#region Imports

import IconExclamation from '@/shared/icons/IconExclamation.vue';

//#endregion
</script>

<template>
  <div class="status-fail">
    <IconExclamation />
  </div>
</template>

<style lang="scss">
.status-fail {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  margin-top: 1rem;

  svg {
    color: var(--alert);
    display: block;
    width: 5rem;
    height: 5rem;
  }
}
</style>
